var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaperPlane = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.7729 48.1055L19.9839 58.984C18.3433 60.9879 15.0034 59.8981 15.0034 57.1324V41.9531L47.8464 12.3317C48.4909 11.7574 49.405 12.6364 48.8542 13.3043L22.4671 45.4535L28.7729 48.1055Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9519 3.28126L51.5144 53.9063C51.4436 54.3248 51.2792 54.722 51.0335 55.0683C50.7878 55.4145 50.4671 55.7008 50.0954 55.9058C49.7237 56.1108 49.3104 56.2293 48.8865 56.2523C48.4626 56.2754 48.039 56.2025 47.6472 56.0391L22.4671 45.4535L48.8542 13.3043C49.405 12.6363 48.4909 11.7574 47.8464 12.3317L14.9999 41.9531L1.7214 36.777C1.23306 36.572 0.812523 36.2332 0.508201 35.7998C0.203879 35.3663 0.0281363 34.8557 0.00119933 34.3268C-0.0257376 33.7978 0.097226 33.272 0.355938 32.8099C0.614651 32.3477 0.998596 31.968 1.46359 31.7145L55.7812 0.378525C57.8073 -0.79335 60.3515 0.917588 59.9519 3.28126Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32.0135,
    y1: 12.1458,
    x2: 32.0135,
    y2: 60.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 29.9956,
    y1: -0.000114441,
    x2: 29.9956,
    y2: 56.2565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaperPlane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paper-plane.05a8aa436e1f5b43f390f793f022caf4.svg";